import { render, staticRenderFns } from "./badge-range.vue?vue&type=template&id=5b28083f&scoped=true"
import script from "./badge-range.vue?vue&type=script&lang=js"
export * from "./badge-range.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b28083f",
  null
  
)

export default component.exports